import {AxiosError} from 'axios';
import {useMutation} from 'react-query';
import {toast} from 'react-toastify';
import PatchToolRequirement from '.';

interface IPatchToolRequirementProps {
  onSuccess?: (data: any) => void;
  guid?: string;
}

const usePatchToolRequirement = ({
  onSuccess,
  guid,
}: IPatchToolRequirementProps) => {
  const {isLoading, mutate, isSuccess} = useMutation({
    mutationFn: (payload: IToolAdvertisementPayload) => {
      return PatchToolRequirement(payload, guid);
    },
    onSuccess: data => {
      onSuccess && onSuccess(data);
    },
    onError: (error: AxiosError<IAxiosErr>) => {
      toast.error(
        error?.response?.data?.message ||
          'مشکلی پیش آمده ،لطفا در زمان دیگری مراجعه فرمایید',
      );
    },
  });

  return {isLoading, mutate, isSuccess};
};

export {usePatchToolRequirement};
